import React from 'react';
import { Modal } from '@cmhc-schl/hearth-ui';
import { useTranslation } from 'react-i18next';

export const UpdateArrearsModal = ({
  isActive,
  loading,
  onClose,
  onConfirm
}: {
  isActive: boolean;
  loading: boolean;
  onClose: () => void;
  onConfirm: () => void;
}) => {
  const { t } = useTranslation('HbtArrearsInquiryPage');

  return (
    <Modal
      id="update-arrears-modal"
      isActive={isActive}
      title={{ value: t('arrearsFlyout.confirmUpdateModal.header') }}
      bodyContent={t('arrearsFlyout.confirmUpdateModal.content')}
      onDismissalCallback={onClose}
      modalButtons={{
        secondaryButton: {
          name: 'secondary',
          text: { value: t('arrearsFlyout.confirmUpdateModal.cancel') },
          ariaText: { value: t('arrearsFlyout.confirmUpdateModal.cancel') },
          onClick: onClose
        },
        primaryButton: {
          name: 'primary',
          text: { value: t('arrearsFlyout.confirmUpdateModal.confirm') },
          ariaText: { value: t('arrearsFlyout.confirmUpdateModal.confirm') },
          onClick: onConfirm,
          loading: loading
        }
      }}
      shouldCloseOnBackgroundClick={true}
      isFocusTrapPaused={true}
    />
  );
};
